import { z } from 'zod';
import { IssueStatusFilterSchema } from '@/features/stacktrace/issues/-constants';
import { IssueSeverity } from '@/features/stacktrace/issues/-query/type';
import { IssueTableColumns } from './-table/type';
const issueSeverityValues = Object.values(IssueSeverity) as [(typeof IssueSeverity)[keyof typeof IssueSeverity], ...(typeof IssueSeverity)[keyof typeof IssueSeverity][]];

/**
 * プロダクション詳細 > 不具合タブ の URL search スキーマ。
 *
 * issues 台帳の URL search を参考にした構成。
 * `productionId` は URL ではなく親 lazy route が `useParams` から取得して
 * 固定値で注入するため、ここでは管理しない（productionProductId フィルタも
 * 親プロダクション固定のため不要）。
 *
 * - status:         ステータスタブ用フィルタ（"ALL" + 6 ドメイン値）
 * - severity:       重要度フィルタ（単一）
 * - freeText:       検索バー（name 部分一致）
 * - pageIndex:      0-origin ページ番号
 * - pageSize:       1 ページあたりの件数
 * - sortColumn:     ソート対象カラム
 * - orderDirection: ソート方向
 */
export const IssueScopeTableFilterSchema = z.object({
  status: IssueStatusFilterSchema.default('ALL'),
  severity: z.enum(issueSeverityValues).optional(),
  freeText: z.string().optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  // 既定は重要度の昇順(BE enum 定義順 critical→…→enhanced。asc で重大が上)。
  sortColumn: z.nativeEnum(IssueTableColumns).default(IssueTableColumns.SEVERITY),
  orderDirection: z.enum(['asc', 'desc']).default('asc')
});